import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createProductionStep } from "../../helpers/http_production_steps_requests";

export default function ProductionStepNew() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const formFieldList = [
        {
            title: "Cadastro de Etapa",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "position",
                    label: "Ordem",
                    type: "number",
                    required: true,
                    helpertext: "Define a posição da etapa no menu de Produção.",
                },
            ],
        },
    ];

    const handleSubmit = (data) => {
        createProductionStep(
            { name: data.name, position: Number(data.position) || 0 },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getProductionSteps"] });
                navigate("/configuracao-etapas");
            }
        );
    };

    return (
        <DynamicFormPage
            title="Etapas - Cadastro"
            onSubmit={handleSubmit}
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
